import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.externalAdminAuth) {
      return next.handle(req);
    }

    // Browser sends the HttpOnly session cookie automatically;
    // withCredentials ensures it is included in cross-origin requests.
    return next.handle(req.clone({ withCredentials: true }));
  }
}
